import { CalendarPlus } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * "Add to Calendar" / "Connect Calendar" for now: calendar integration isn't built yet,
 * so every calendar entry point opens this and nothing else.
 */
export function CalendarComingSoonDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        overlayClassName="z-[100]"
        className="z-[101] w-[calc(100%-2rem)] sm:max-w-[400px] rounded-[26px] border border-foreground/[0.08] bg-background p-0 gap-0 shadow-[0_24px_60px_-12px_rgba(47,41,37,0.22),0_1px_2px_rgba(47,41,37,0.05)] overflow-hidden"
      >
        <div className="relative px-6 pt-10 pb-2">
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-lavender-wash/80 via-transparent to-transparent" />
          <div className="relative mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-[20px] bg-white text-primary ring-1 ring-foreground/[0.08] shadow-[0_6px_16px_-6px_rgba(47,41,37,0.18)]">
            <CalendarPlus className="h-8 w-8" strokeWidth={1.5} />
          </div>
          <DialogHeader className="relative space-y-3">
            <DialogTitle className="font-display text-center text-2xl font-semibold tracking-[-0.03em] text-foreground">
              Calendar integration is coming soon
            </DialogTitle>
            <DialogDescription className="text-center text-[15px] leading-relaxed text-muted-foreground">
              Soon you&apos;ll be able to turn your Momentum into scheduled actions with Google Calendar and
              Apple Calendar.
            </DialogDescription>
          </DialogHeader>
        </div>
        <DialogFooter className="relative mt-4 border-t border-foreground/[0.06] px-6 py-5 sm:flex-col">
          <Button className="h-12 w-full rounded-full text-base font-medium" onClick={() => onOpenChange(false)}>
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
